import React, { useState } from 'react';
import { Typography } from '@material-ui/core';
import { Box, Grid, InputAdornment, TextField } from '@mui/material';
import { Search } from '@material-ui/icons';
import HomepageCard from './components/Homepage/HomepageCard';
import {
    FolderIcon,
    HomeIcon,
    LicenseGlobalIcon,
    ListCheckedIcon,
    ReportDataIcon,
    ReportIcon,
    TemplateIcon,
    UserAdminIcon
} from './utils/Icons';
import Navbar from './components/Common/Navbar';

const defaultOptions = [
    {
        title: 'Standards & Laws',
        link: '/library',
        // icon: <Description />
        icon: <LicenseGlobalIcon />
    },
    {
        title: 'Self Assessment',
        link: '/self-assessment',
        // icon: <AssignmentInd />
        icon: <ReportDataIcon />
    },
    {
        title: 'Audit',
        link: '/audit',
        icon: <ReportIcon />
    },
    {
        title: 'Document Storage',
        link: '/document-storage',
        icon: <FolderIcon />
    },
    {
        title: 'Templates',
        link: '/templates',
        icon: <TemplateIcon />
    },
    {
        title: 'CAPA',
        link: '/capa',
        icon: <ListCheckedIcon />
    },
    {
        title: 'Admin',
        link: '/admin',
        icon: <UserAdminIcon />
    }
];

const Homepage = () => {
    const [searchTerm, setSearchTerm] = useState('');

    const [options, setOptions] = React.useState(defaultOptions);

    const handleSearchInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchTerm(event.target.value);
        if (!event.target.value) {
            setOptions(defaultOptions);
        } else {
            setOptions(options.filter((item: any) => item.title.includes(event.target.value)));
        }
    };

    return (
        // <div className="homepage">
        <>
            <Navbar />
            <Grid
                container
                className="d-flex justify-content-between align-items-center px-3 py-2 mb-5"
                sx={{ boxShadow: '0px 1px 0px 0px #79797940' }}
            >
                {' '}
                <Grid item xs={6} className="d-flex justify-content-start align-items-center">
                    <Box
                        className="px-2 pb-2 me-3"
                        sx={{ width: 'fit-content', backgroundColor: '#F2F2F2', borderRadius: '6px' }}
                    >
                        <HomeIcon width={17} height={16} />
                    </Box>
                    <Typography style={{ color: '#475565' }} className="text-capitalize">
                        HOMEPAGE
                    </Typography>
                </Grid>
                <Grid item xs={6} className="d-flex justify-content-end align-items-center">
                    <TextField
                        required
                        name="search"
                        placeholder="Search"
                        variant="outlined"
                        size="small"
                        value={searchTerm}
                        onChange={handleSearchInputChange}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    {' '}
                                    <Search />
                                </InputAdornment>
                            )
                        }}
                        sx={{
                            width: {
                                md: '50%',
                                xs: '80%'
                            }
                        }}
                    />
                </Grid>
            </Grid>

            <Grid
                container
                className="mb-4"
                gap={{ lg: 1.5, md: 1, xs: 1 }}
                sx={{
                    isolation: 'isolate',
                    width: { md: '85%', sm: '90%', xs: '90%' },
                    marginLeft: 'auto',
                    marginRight: 'auto'
                }}
            >
                {options.map((option, index) => (
                    <HomepageCard data={option} index={index} key={option.title} />
                ))}
            </Grid>
        </>
    );
};

export default Homepage;
